import React, { FC, ReactNode } from 'react';
import { TanstackTableLocaleProvider, TanstackTableLocale } from '@thingslog/ui-components';
import { useTableLocale } from '../hooks/useTableLocale';

interface Props {
  children: ReactNode;
}

/**
 * `App.js` is a class component, so it cannot call the locale hook itself.
 * This wrapper does, and provides the result to every table below it.
 */
export const TanstackTableLocaleSetup: FC<Props> = ({ children }: Props) => {
  const locale: TanstackTableLocale = useTableLocale();

  return <TanstackTableLocaleProvider locale={locale}>{children}</TanstackTableLocaleProvider>;
};
